var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "team_x2C__crew_x2C__group_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 9C6.346 9 5 7.654 5 6s1.346 -3 3 -3 3 1.346 3 3 -1.346 3 -3 3zm0 -5c-1.103 0 -2 0.897 -2 2s0.897 2 2 2 2 -0.897 2 -2 -0.897 -2 -2 -2z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-5a0.5 0.5 0 0 1 1 0v5a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21a0.5 0.5 0 0 1 -0.5 -0.5v-7C3 11.882 4.311 10 6 10h4.5a0.5 0.5 0 0 1 0 1H6c-1.077 0 -2 1.375 -2 2.5v7a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5 24H2c-0.551 0 -1 -0.448 -1 -1v-2c0 -0.552 0.449 -1 1 -1h3c0.551 0 1 0.448 1 1v2c0 0.552 -0.449 1 -1 1zm0 -1v0.5zm-3 -2v2h2.999L5 21z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26 9c-1.654 0 -3 -1.346 -3 -3s1.346 -3 3 -3 3 1.346 3 3 -1.346 3 -3 3zm0 -5c-1.103 0 -2 0.897 -2 2s0.897 2 2 2 2 -0.897 2 -2 -0.897 -2 -2 -2z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-10a0.5 0.5 0 0 1 0.5 -0.5 0.5 0.5 0 0 0 0.5 -0.5v-6c0 -1.125 -0.923 -2.5 -2 -2.5h-4.5a0.5 0.5 0 0 1 0 -1H28c1.689 0 3 1.882 3 3.5v6c0 0.652 -0.418 1.208 -1 1.414V30.5a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 24h-1.5a0.5 0.5 0 0 1 0 -1H24v-2h-1.5a0.5 0.5 0 0 1 0 -1H24c0.551 0 1 0.448 1 1v2c0 0.552 -0.449 1 -1 1z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 7c-1.654 0 -3 -1.346 -3 -3s1.346 -3 3 -3 3 1.346 3 3 -1.346 3 -3 3zm0 -5c-1.103 0 -2 0.897 -2 2s0.897 2 2 2 2 -0.897 2 -2 -0.897 -2 -2 -2z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-7a0.5 0.5 0 0 1 1 0v7a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-7a0.5 0.5 0 0 1 1 0v7a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-6a0.5 0.5 0 0 1 1 0v6a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-11a0.5 0.5 0 0 1 0.5 -0.5 0.5 0.5 0 0 0 0.5 -0.5v-7c0 -1.125 -0.923 -2.5 -2 -2.5h-4c-1.077 0 -2.063 1.386 -2.114 2.521l-0.386 8.003a0.5 0.5 0 0 1 -0.999 -0.048l0.387 -8.002C11.961 9.835 13.309 8 15 8h4c1.689 0 3 1.882 3 3.5v7c0 0.652 -0.418 1.208 -1 1.414V30.5a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.5v-9z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 31a0.5 0.5 0 0 1 -0.5 -0.5v-9a0.5 0.5 0 0 1 1 0v9a0.5 0.5 0 0 1 -0.5 0.5z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 23h-3c-0.551 0 -1 -0.448 -1 -1v-2c0 -0.552 0.449 -1 1 -1h3c0.551 0 1 0.448 1 1v2c0 0.552 -0.449 1 -1 1zm0 -1v0.5zm-3 -2v2h2.999L14 20z",
    fill: "#E2C395",
    stroke: "#E2C395",
    strokeWidth: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2ab22edc562afce1e3e7fcb6e9081c03.svg";
export { ForwardRef as ReactComponent };